import React from "react";

const HeartIcon = ({ width = "1rem", height = "1rem", fill = "black" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3274 3.51805C18.0804 3.48695 17.8303 3.47097 17.5836 3.47097C15.4253 3.47097 13.7566 4.62503 12.6434 5.74804C11.5731 3.56508 9.89989 2.16301 7.88471 1.77611C7.57137 1.71601 7.24773 1.68536 6.92189 1.68536C4.49835 1.68536 1.87363 3.42258 0.680779 5.81637C-0.522372 8.23162 -0.130198 10.8671 1.8477 13.6491C3.83887 16.4504 6.3238 18.8874 8.72709 21.2444L9.22247 21.7305C9.41079 22.0877 9.769 22.3143 10.1557 22.3145C10.3162 22.3145 10.4748 22.276 10.6268 22.2L11.4955 21.7686C14.5109 20.2716 17.6287 18.7241 20.39 16.677C23.1321 14.6445 24.3216 12.2604 23.9254 9.59089C23.5266 6.9021 21.3236 3.89525 18.3274 3.51805ZM21.9696 11.0863C21.8719 13.3698 19.3092 15.0079 17.6137 16.0922C15.3026 17.5696 12.8192 18.8165 10.4073 20.0177C8.45088 18.0947 6.4355 16.1055 4.66894 13.9528C3.39243 12.3971 1.46307 10.0462 2.07738 7.84452C2.6323 5.85592 4.68336 3.72708 6.85164 3.72708C6.99092 3.72708 7.13091 3.73627 7.26793 3.75401C9.77608 4.08136 10.8687 6.57444 11.2421 7.72046C11.2259 7.95109 11.2996 8.1769 11.4551 8.36588C11.6612 8.61666 11.9812 8.76659 12.311 8.76659C12.6534 8.76659 12.9637 8.60098 13.1627 8.31206C13.7403 7.47365 15.3271 5.52288 17.5844 5.52288C17.8224 5.52288 18.0636 5.54534 18.3011 5.59011C20.5176 6.0046 22.0658 8.83392 21.9696 11.0863Z"
      fill={fill}
    />
  </svg>
);

export default HeartIcon;
